import userManager from './userManager';

import AUTHENTICATED from './actions/AUTHENTICATED';
import LOGGEDOUT from './actions/LOGGEDOUT';
import { buttonLogout, originNoteMenu } from '../focuslock/actions/UPDATE_BUTTON_NO';
import ACCOUNDMANAGER from './actions/ACCOUNDMANAGER';

export function setupStore(store: any) {


        userManager(async (um) => {
            um.events.addUserLoaded(async () => {
                acceptUser(await um.getUser());
                // console.log(`[Auth] User loaded`);            
            });
            um.events.addUserUnloaded(() => {
                store.dispatch(LOGGEDOUT({ }));
                // // tslint:disable-next-line
                // console.warn(`[Auth] User unloaded`);
            });
            um.events.addUserSignedOut(() => {
                store.dispatch(LOGGEDOUT({ }));
                // tslint:disable-next-line
                // console.warn(`[Auth] User signed out`);
            });
            um.events.addAccessTokenExpiring(() => {
                // tslint:disable-next-line
                console.warn(`[Auth] Acces token expiring`);
            });
            um.events.addAccessTokenExpired(() => {
                store.dispatch(LOGGEDOUT({ }));
                // tslint:disable-next-line
                console.warn(`[Auth] Acces token expired`);
            });
            um.events.addSilentRenewError(() => {
                store.dispatch(LOGGEDOUT({ }));
                // tslint:disable-next-line
                console.warn(`[Auth] Silent renew error`);
            });
                    
            await um.clearStaleState();
            acceptUser(await um.getUser());
            recentLogin(await um.getUser());

            function acceptUser(user: Oidc.User) {

                if (user && !user.expired) {                
                    store.dispatch(AUTHENTICATED({ token: user.access_token, user: { name: getUsername(user), email: getUserEmail(user), tenant: getUserTenant(user) } }));
                    const base64Url = user.access_token.split('.')[1];
                    const base64 = base64Url.replace('-', '+').replace('_', '/');
                    const res=JSON.parse(window.atob(base64));
                    var accountmanager = false;
                    if (res['app-admin']) {
                        // tslint:disable-next-line
                        // if (res['app-admin'].qFirst((item: any)=> item==='accntman')) {
                        //     accountmanager = true;                    
                        // }
                        accountmanager = (res['app-admin'].indexOf('accntman')!==-1);
                    }
                    store.dispatch(ACCOUNDMANAGER({accountmanager: accountmanager}));
                    // // tslint:disable-next-line
                    // console.log(`[Auth] User loaded`);
                }
            }
            function recentLogin(user: Oidc.User) {
                if (user && !user.expired) { 
                    // var authtime = user.profile.auth_time;
                    // var datenow = new Date();
                    // var currtime = datenow.getTime();

                    // within 5 seconds
                    /* tslint:disable no-magic-numbers */
                    // if (((currtime - authtime*1000)/1000<5)) {
                    //     console.log("Yeahhh");
                    //     store.dispatch(SHOW({buttonNo: buttonLogout, origin: originNoteMenu}));
                    // } else {
                    //     store.dispatch(NOTEMENU_ERASE({ }));
                    // }
                    /* tslint:enable */
                }
            }
        }); 

}

function getUsername(user: Oidc.User): string {
    if (user.profile.preferred_username) {
        return lastOrValue(user.profile.preferred_username);
    }
    if (user.profile.name) {
        return `${user.profile.name}`;
    }
    if (user.profile.given_name && user.profile.family_name) {
        return `${user.profile.given_name} ${user.profile.family_name}`;
    }
    if (user.profile.email) {
        return `${user.profile.email}`;
    }
    return `?`;
}

function getUserEmail(user: Oidc.User): string {
    if (user.profile.email) {
        return `${user.profile.email}`;
    }
    return ``;
}

function getUserTenant(user: Oidc.User): string {
    if (user.profile.tenant) {
        return `${user.profile.tenant}`;
    }
    return ``;
}

function lastOrValue<T>(arg: T | T[]): T {
    if (arg instanceof Array) {
        return arg[arg.length - 1];
    } else {
        return arg;
    } 
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/auth/setup.tsx